<template>
	<div class="mb-5">
		<div v-loading="!ready">



			<div class="w-100 account-header">
				<h2 class="mb-none">Payment Info</h2>
				<a class="action" v-if="user.hasPermission && payment !== null && isViewingOwnProfile" @click.prevent="form = true"><i class="el-icon-edit float-right"></i></a>
				<em v-if="isViewingOwnProfile">Visible To You Only</em>
			</div>

			<hr class="solid mt-xs">

			<div v-if="ready">

				<div v-if="payment">
					<div v-if="payment.cardType">
						<div class="row">
							<div class="col-sm-6 col-xl-4">
								<dl>
									<dt>Credit Card</dt>
									<dd>{{payment.cardType}} ending in {{payment.suffixOnCard}}</dd>
								</dl>
							</div>
							<div class="col-sm-6 col-xl-4">
								<dl>
									<dt>Expiration</dt>
									<dd>{{payment.expireDate}}</dd>
								</dl>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="row">
							<div class="col-sm-6 col-xl-4">
								<dl>
									<dt>Bank Transfer</dt>
									<dd>{{payment.accountType}} ending in {{payment.accountNumber}}</dd>
								</dl>
							</div>
							<div class="col-sm-6 col-xl-4">

							</div>
						</div>
					</div>



				</div>

				<div v-else>
					<el-alert :title="paymentError" v-if="paymentError"
										type="error"
										effect="dark"
										show-icon
										:closable="false" class="mt-4 mb-4">
					</el-alert>
					<p v-else>
						We currently do not have any payment information on file for you.
					</p>
				</div>


			</div>


			<div class="w-100 account-header">
				<h2 class="mb-none">Membership Info</h2>
				<router-link class="action" :to="{ name: 'manage-membership' }"><i class="el-icon-edit float-right"></i></router-link>
				<el-alert type="error" v-if="payment && payment.statusMessage !== null" :closable="false" :title="payment.statusMessage" />
			</div>
			<em v-if="isViewingOwnProfile">Visible To You Only</em>
			<hr class="solid mt-xs">

			<div v-if="ready.payment && ready.family && payment !== null">

				<div class="row">
					<div class="col-sm-4">
						<dl>
							<dt>Membership</dt>
							<dd>{{payment.productName}}</dd>
						</dl>
					</div>
					<div class="col-sm-4">
						<dl>
							<dt>Last Payment</dt>
							<dd>{{payment.lastPayment}}</dd>
						</dl>
					</div>
					<div class="col-sm-4">
						<dl>
							<dt>Next Payment</dt>
							<dd>{{payment.nextPayment}}</dd>
						</dl>
					</div>

				</div>

				<div class="row">
					<div class="col-sm-4">
						<dl>
							<dt>Cancel Date</dt>
							<dd>{{payment.futureStatusDate}}</dd>
						</dl>
					</div>

					<div class="col-sm-4">
						<dl>
							<dt>Cancel Policy</dt>
							<dd>{{payment.cancelPolicy}}</dd>
						</dl>
					</div>
					<div class="col-sm-4">
						<dl>
							<dt>Video On Demand Policy</dt>
							<dd>{{payment.vodPolicy}}</dd>
						</dl>
					</div>

				</div>

				<div class="row">

					<div class="col-sm-4">
						<dl>
							<dt>Price</dt>
							<dd>${{payment.price}}</dd>
						</dl>
					</div>


					<div class="col-sm-4">
						<dl>
							<dt>Included Classes</dt>
							<dd>{{payment.includedClasses}}</dd>
						</dl>
					</div>

					<div class="col-sm-4">
						<dl>
							<dt>Family Member(s)</dt>
							<dd>{{payment.numFamily}}</dd>
						</dl>
					</div>


				</div>

				<div class="row">


					<div class="col-sm-4">
						<dl>
							<dt>Max Paid Classes</dt>
							<dd>{{payment.maxClasses}}</dd><!--{{memberMaxClasses}}-->
						</dl>
					</div>

					<div class="col-sm-4">

						<dl>
							<dt>Cost Per Class After Max</dt>
							<dd>{{payment.costPerClassAfterMax}}</dd>
						</dl>

					</div>

					<div class="col-sm-4">
						<dl>
							<dt>Drop In</dt>
							<dd>{{payment.dropIn}}</dd>
						</dl>
					</div>

				</div>

				<router-link v-if="payment.statusId === 'PS_ACTIVE'" class="btn btn-primary" :to="{ name: 'manage-membership' }">Change My Membership</router-link>
				<router-link v-else-if="user.acceptText === 'Test' && payment.statusId === 'PS_CANCELLED'" class="btn btn-primary" :to="{ name: 'manage-membership' }">Purchase Your Special Offer!</router-link>
				<router-link v-else-if="user.acceptText !== 'Test' && payment.statusId === 'PS_CANCELLED'" class="btn btn-primary" :to="{ name: 'manage-membership' }">Purchase A Membership, Pass or Class Card</router-link>

			</div>
			<div v-else>
				<el-alert :title="familyError" v-if="familyError"
									type="error"
									effect="dark"
									show-icon
									:closable="false" class="mt-4 mb-4">
				</el-alert>
				<p v-else>
					We currently do not have membership information on file for you.
				</p>
			</div>

		</div>

			<el-dialog title="Payment Info"
								 :visible.sync="form"
								 :width="modalWidth"
								 :close-on-click-modal="false"
								 :before-close="clearForm"
								 :append-to-body="false">


				<div v-if="ready.payment && payment !== null">
					<template v-if="formView === 'prompt'">
						<div v-if="payment.cardType" class="text-center">
							<p>We currently have your {{payment.cardType}} ending in {{payment.suffixOnCard}} on file. What would you like to do?</p>
							<el-button type="link" style="width: 175px" class="mb-2" @click.prevent="formView = 'card'">Replace This Card</el-button>
							<el-button type="link" style="width: 175px" @click.prevent="formView = 'eft'">Checking/Savings</el-button>
						</div>
						<div v-else class="text-center">
							<p>We currently have your {{payment.accountType}} Account ending in {{payment.accountNumber}} on file. What would you like to do?</p>
							<el-button type="link" class="mb-2" style="width: 175px" @click.prevent="formView = 'eft'">Replace This Account</el-button>
							<el-button type="link" style="width: 175px" @click.prevent="formView = 'card'">Use a Credit Card</el-button>
						</div>
					</template>

					<template v-if="formView === 'card'">
						<CardForm ref="cardform" @valid="confirm($event)" :formData="formData"></CardForm>
					</template>
					<template v-else-if="formView === 'eft'">
						<BankForm ref="bankform" @valid="confirm($event)" :formData="formData"></BankForm>
					</template>
				</div>






				<el-alert :title="serverError" v-if="serverError"
									type="error"
									effect="dark"
									show-icon
									:closable="false" class="mt-4">
				</el-alert>



				<span slot="footer" class="dialog-footer">
					<el-button :disabled="thinking.save" @click="clearForm">Cancel</el-button>
					<el-button :loading="thinking.save" v-if="formView !== 'prompt'" type="primary" @click="submit">Confirm</el-button>
				</span>
			</el-dialog>


		</div>
	</template>

	<script>
		import { rest } from "@/utilities/rest.js";
		import CardForm from "@/components/payment/components/CardForm";
		import BankForm from "@/components/payment-ach/components/CardForm";
		import { mapActions, mapGetters } from "vuex";

		export default {
			name: "payment-info",
			data() {
				return {
					form: false,
					formView: "prompt",
					data: {

					},
					//payment: null,
					formData: {
						firstname: '',
						lastname: '',
						cardNumber: '',
						cardMonth: '',
						cardYear: '',
						cardCvv: '',
						cardZip: '',
						bankName: '',
						routingNumber: '',
						accountNumber: '',
						accountType: ''
					},
					ready: {
						payment: false,
						family: false
					},

					// for dialog
					serverError: null,

					paymentError: null,
					familyError: null,


					thinking: {
						save: false,
						visible: false
					}
				}
			},

			components: {
				CardForm,
				BankForm
			},

			created() {
				this.data = JSON.parse(JSON.stringify(this.user));
				this.fetch();

			},

			computed: {
				...mapGetters({
					payment: "payment",
					modalWidth: "modalWidth"
				})
			},

			methods: {
				...mapActions({
					getPayment: "getPayment",
					getFamilyMembers: "getFamilyMembers"
				}),

				clearForm() {

					for (var prop in this.formData) {
						if (this.formData.hasOwnProperty(prop)) {
							this.formData[prop] = "";
						}
					}

					this.formView = 'prompt';
					this.form = false;
				},

				fetch() {
					this.getPayment(this.user.userId).then(response => {
						this.ready.payment = true;
					}, error => {
						this.paymentError = error;
					});

					this.getFamilyMembers(this.user.userId).then(response => {
						this.ready.family = true;
					}, error => {
						this.familyError = error;
					});

				},

				confirm() {
					this.thinking.save = true;
					this.formData.userId = this.data.userId;
					this.formData.method = this.formView;
					rest.post("Account", "/UpdatePaymentInfo", "json", JSON.stringify(this.formData)).done(response => {
						this.form = false;
						setTimeout(() => {
							this.$message.success("Changes have been saved.");
						}, 1000);
						this.$emit("fetch", "payment");
					}).fail((error) => {
						this.serverError = JSON.parse(error.responseText);
					}).always(() => {
						this.thinking.save = false;
					});
				},

				submit(valid) {
					if (this.formView === 'card') {
						this.$refs.cardform.handleSubmit();
					} else {
						this.$refs.bankform.handleSubmit();
					}

				},

				cancelMembership(confirm) {
					if (!confirm) {
						this.$confirm('Are you sure you want to cancel your membership?', 'Please Confirm', {
							confirmButtonText: 'Yes',
							cancelButtonText: 'Cancel',
							type: 'warning'
						}).then(() => {
							this.formData.userId = this.data.userId;
							rest.post("Account", "/CancelMembership", "json", JSON.stringify(this.formData)).done(response => {
								setTimeout(() => {
									this.$message.success("Changes have been saved.");
								}, 1000);
								this.$emit("fetch");
							}).fail((error) => {
								alert(JSON.parse(error.responseText));
							});
						}).catch(() => {

						});
					}
				}
			},

			props: ["user", "isViewingOwnProfile"],

			watch: {
				form(val) {
					if (val) {
						this.data = JSON.parse(JSON.stringify(this.user));
						//this.data.password = "";
						this.$validator.reset();
					}
				}
			}
		}
	</script>
